//components
import Item from "./Item"

const List = ({ data }) => {
    const { items } = data

    return (
        <ul>
            {(items || []).map((i, j) =>
                <Item
                    key={`topic-${i.id}`}
                    data={i}
                    index={j}
                />
            )}
        </ul>
    )
}

export default List